/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface LinkCadabraWalletRequest
 */
export interface LinkCadabraWalletRequest {
  /**
   *
   * @type {string}
   * @memberof LinkCadabraWalletRequest
   */
  cadabraAddress?: string
}

export function LinkCadabraWalletRequestFromJSON(json: any): LinkCadabraWalletRequest {
  return LinkCadabraWalletRequestFromJSONTyped(json, false)
}

export function LinkCadabraWalletRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LinkCadabraWalletRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    cadabraAddress: !exists(json, 'cadabraAddress') ? undefined : json['cadabraAddress'],
  }
}

export function LinkCadabraWalletRequestToJSON(value?: LinkCadabraWalletRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    cadabraAddress: value.cadabraAddress,
  }
}
